import React, {useEffect, useState} from "react";
import prod1 from "../images/prod01.png";
import prod2 from "../images/prod02.png";
import prod3 from "../images/prod03.png";
import Axios from "axios";
import { profileUser } from "../api/service";
import { useNavigate } from "react-router";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const products = [
    {
        id: 1,
        name: "Suraksha Pen",
        image: prod3,
        isNew: true,
        points: 150,
      },
  {
    id: 2,
    name: "Jal Suraksha T-Shirt",
    image: prod1,
    isNew: true,
    points: 400,
  },
  {
    id: 3,
    name: "Shakti Badge",
    image: prod2,
    isNew: true,
    points: 550,
  },
  
];

const Redeem = () => {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  let token = localStorage.getItem("token");
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        // setName(req.data.userValidation.name);
        setId(req.data.userValidation._id)
        console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaa')
        console.log(req.data.userValidation)
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };
  const handleRedeemClick = () => {
    Axios.put(process.env.REACT_APP_API_BASE_URL + "/api/users/updateTokens/" +id + "/" + 10).then((res) => {
      console.log(res.data);
      toast.info(`Goodies claimed`);
    }).catch((err) => {
      if(err.response.status == 500 ){
        toast.info(`Not enough tokens`);
      }
    });
  };
  useEffect(() => {
    profileInit();
  }, []);

  return (
    <div>
      <h1 className="block text-3xl font-bold text-center p-5 text-gray-800 sm:text-4xl lg:text-6xl lg:leading-tight dark:text-white">
        Redeem your Shakti Points
      </h1>
      <div className="flex flex-wrap justify-center">
        {products.map((product) => (
          <div
            key={product.id}
            className="relative m-10 flex w-full max-w-xs flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md"

          >
            <div
              className="relative mx-3 mt-3 flex h-60 overflow-hidden rounded-xl"
            >
              <img
                className="object-cover"
                src={product.image}
                alt="product image"
              />
              {product.isNew && (
                <span className="absolute top-0 left-0 m-2 rounded-full bg-black px-2 text-center text-sm font-medium text-white">
                  New
                </span>
              )}
            </div>
            <div className="mt-4 px-5 pb-5">
                <h5 className="text-xl tracking-tight text-slate-900">
                  {product.name}
                </h5>
              <div className="my-3 flex items-center justify-between">
                <p>
                  <span className="text-xl font-bold text-slate-900">
                    <span className="inline-flex items-center px-2 font-bold text-md py-1 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#145ca9"
                          d="M11 18h1l4-6h-3V8h-1l-4 6h3zm1 4q-3.425 0-5.712-2.35T4 13.8q0-2.5 1.988-5.437T12 2q4.025 3.425 6.013 6.363T20 13.8q0 3.5-2.287 5.85T12 22m0-2q2.6 0 4.3-1.763T18 13.8q0-1.825-1.513-4.125T12 4.65Q9.025 7.375 7.513 9.675T6 13.8q0 2.675 1.7 4.438T12 20m0-8"
                        />
                      </svg>{" "}
                      {product.points}
                    </span>
                  </span>
                </p>
              </div>
              <button
                onClick={handleRedeemClick}
                className="flex items-center justify-center rounded-md bg-slate-900 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-6 w-6" viewBox="0 0 256 256"><path fill="#e3e3e3" d="M219.68 117.26a12 12 0 0 0-7.47-8.5l-54.44-20.41l14-70a12 12 0 0 0-20.54-10.54l-112 120a12 12 0 0 0 4.56 19.43l54.44 20.41l-14 70a12 12 0 0 0 20.54 10.54l112-120a12 12 0 0 0 2.91-10.93m-103.63 83.67l7.72-38.58a12 12 0 0 0-7.56-13.59L69 131.07l70.93-76l-7.72 38.58a12 12 0 0 0 7.56 13.59L187 124.93Z"/></svg>
                Redeem now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Redeem;